"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Type = void 0;

require("core-js/modules/es6.object.assign");

var _react = _interopRequireDefault(require("react"));

var _headings = require("./headings");

var _body = _interopRequireDefault(require("./body"));

var _primitives = require("../primitives");

var Type = function Type(p) {
  return _react.default.createElement(_primitives.Inline, p);
};

exports.Type = Type;
Type.h1 = _headings.Headings.H1;
Type.h2 = _headings.Headings.H2;
Type.h3 = _headings.Headings.H3;
Type.h4 = _headings.Headings.H4;
Type.h5 = _headings.Headings.H5;
Type.h6 = _headings.Headings.H6;
Type.p = _body.default.p;
Type.span = _body.default.span;
Type.ui = _body.default.ui;
Type.a = _body.default.a;
Type.strong = _body.default.strong;
Type.em = _body.default.em;
Type.ul = _body.default.ul;
Type.ol = _body.default.ol;
Type.li = _body.default.li;
Type.oli = _body.default.oli;
Type.pre = _body.default.pre;
var basePropTypes = {};
Type.h1.propTypes = Object.assign({}, basePropTypes);
Type.h2.propTypes = Object.assign({}, basePropTypes);
Type.h3.propTypes = Object.assign({}, basePropTypes);
Type.h4.propTypes = Object.assign({}, basePropTypes);
Type.h5.propTypes = Object.assign({}, basePropTypes);
Type.h6.propTypes = Object.assign({}, basePropTypes);
Type.p.propTypes = Object.assign({}, basePropTypes);
Type.strong.propTypes = Object.assign({}, basePropTypes);
Type.em.propTypes = Object.assign({}, basePropTypes);
Type.ul.propTypes = Object.assign({}, basePropTypes);
Type.ol.propTypes = Object.assign({}, basePropTypes);
Type.li.propTypes = Object.assign({}, basePropTypes);
Type.oli.propTypes = Object.assign({}, basePropTypes);
Type.pre.propTypes = Object.assign({}, basePropTypes);
Type.propTypes = Object.assign({}, basePropTypes);